// extracted by mini-css-extract-plugin
export default {"wrapper":"zfa","container":"Afa","title":"Bfa","carousel":"Cfa","review":"Efa","name":"Ffa","rating":"Gfa","heading":"Hfa","body":"Ifa"};
    if(module.hot) {
      // 1730991513150
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  